import request from '@/utils/request'

export function add(data) {
    return request({
        url: 'api/specifictraining',
        method: 'post',
        data
    })
}

export function del(id) {
    return request({
        url: 'api/specifictraining/' + id,
        method: 'delete'
    })
}

export function edit(data) {
    return request({
        url: 'api/specifictraining',
        method: 'put',
        data
    })
}
